export default {
      id: "video-request_smart-search-accident-usage",
      viewBox: "0 0 33 20",
      url: __webpack_public_path__ + "img/icons.svg#video-request_smart-search-accident",
      toString: function () {
        return this.url;
      }
    }